import { getFilteredEvents } from '@/redux/actions/events'
import { IRootState } from '@/redux/types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

function useHandleFilters() {
  const dispatch = useDispatch()

  const { reload } = useSelector((state: IRootState) => state.event)
  const { globalFamilyId, globalBrandId, globalLineId, globalCountriesId, globalLanguageId } = useSelector(
    (state: IRootState) => state.global
  )

  useEffect(() => {
    if (reload) {
      dispatch(
        getFilteredEvents({
          family_id: globalFamilyId,
          brand_id: globalBrandId,
          line_id: globalLineId,
          language_id: globalLanguageId,
          countries: globalCountriesId
        })
      )
    }
  }, [reload])

  useEffect(() => {
    if (globalLanguageId !== null && globalCountriesId.length > 0) {
      dispatch(
        getFilteredEvents({
          family_id: globalFamilyId,
          brand_id: globalBrandId,
          line_id: globalLineId,
          language_id: globalLanguageId,
          countries: globalCountriesId
        })
      )
    }
  }, [globalFamilyId, globalBrandId, globalLineId, globalLanguageId, globalCountriesId])

  const handleClickSetOptions = (options: any) => {
    dispatch(
      getFilteredEvents({
        brand_id: globalBrandId,
        line_id: globalLineId,
        language_id: globalLanguageId,
        countries: globalCountriesId,
        filterBy: options
      })
    )
  }

  return { handleClickSetOptions }
}

export default useHandleFilters
